import { Button, Grid, Typography, makeStyles } from "@material-ui/core";
import CustomizedTables from "../../atoms/table";
import { StyledTableCell, StyledTableRow } from "../../atoms/table/tableStyles";
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';


const useStyles = makeStyles((theme) => ({
    title: {
        marginTop: 10
    }

}));

const tableHeader = [
    { label: 'Severity', _id: 'severity' },
    { label: 'Changes', _id: 'changes' },
]

export const PlatformSchemaMigrationWarnings = ({ compatibilityErrors, isFetching, onClose }) => {
    const classes = useStyles();


    return (
        <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12}>
                <Typography
                    variant="subtitle1"
                    className={classes.title}
                >
                    Platform Schema Migration Issues
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <CustomizedTables id="migration_warning_table" size="small" headers={tableHeader}>
                    {isFetching ? <StyledTableRow>
                        <StyledTableCell align={'center'} colSpan={3} component="td" style={{ padding: 15 }}>
                            Loading..
                        </StyledTableCell>
                    </StyledTableRow>

                        :
                        compatibilityErrors?.length < 1 ? (
                            <StyledTableRow>
                                <StyledTableCell align={'center'} colSpan={3} component="td" style={{ padding: 15 }}>
                                    No migration issues found.
                                </StyledTableCell>
                            </StyledTableRow>
                        ) : (
                            compatibilityErrors?.map((item, index) => (
                                <StyledTableRow key={index}>
                                    <StyledTableCell align={'left'}>{item.type === "error" ? <ErrorIcon style={{ color: "#db5757" }} /> :
                                        <WarningIcon style={{ color: "#fbc02d" }} />
                                    }</StyledTableCell>
                                    <StyledTableCell align={'left'}>{item.message}</StyledTableCell>
                                </StyledTableRow>
                            ))
                        )}
                </CustomizedTables>
            </Grid>
            <Grid item xs={12} style={{ paddingTop: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
                <Button id="go_back_btn" color="primary" variant="contained" onClick={() => onClose()} style={{ textTransform: "none" }}>
                    Go Back
                </Button>
            </Grid>
        </Grid>
    )
}